import styles from './index.module.scss';
import EfImg from 'elem/ui/ef-img';
import { useLang } from '@/i18n';

const Resource = () => {
    const { t } = useLang('rule');

    return (
        <div className={styles.resource}>
            <div className="text-container">
                <h2 className="title">{t('D_title')}</h2>
                <p className="intro">{t('D_desc')}</p>
            </div>
            <ul className="D-list">
                <li className="D-list-item">
                    <EfImg className="D-list-item-img" pc="https://websiteoss.ecoflow.com/upload/image/1786355204365/file.png" />
                    <div className="D-list-item-text">
                        <h3 className="D-list-item-title">{t('D_list_title1')}</h3>
                    </div>
                </li>
            </ul>
        </div>
    );
};

export default Resource;
